import React from "react";

export default function Marquee({ items, className = "" }) {
  const row = [...items, ...items];
  return (
    <div className={`relative overflow-hidden border-y border-border bg-[#FF1A1A] text-white py-4 ${className}`} data-testid="editorial-marquee">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((item, i) => (
          <span key={i} className="font-display font-bold uppercase tracking-widest text-sm sm:text-base px-8 flex items-center gap-8">
            {item}
            <span className="inline-block w-2 h-2 bg-white rotate-45" />
          </span>
        ))}
      </div>
    </div>
  );
}
